import { LoginPage } from "pages/login";

export default function LoginRoute() {
  return <LoginPage />;
}
